module.exports = __webpack_public_path__ + "static/img/screenkey1.f4f6e11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/screen/screenkey1.gif
// module id = DgnA
// module chunks = 0